/** Standalone flyaway popups for non-game UI (menu, shop). The in-game
 *  Renderer has its own `showDamagePopup` for combat/stat flyaways;
 *  this module is for menu/shop interactions where there's no Renderer
 *  instance to hang the helper on.
 *
 *  Popups are appended to `document.body` (not the anchor's container)
 *  so they survive re-renders of the surrounding view. The caller is
 *  expected to capture the anchor's bounding rect BEFORE any UI
 *  refresh; once the popup is on body it's positioned by viewport
 *  coordinates and floats independently. */

function spawnFlyaway(rect: DOMRect, className: string, text: string): void {
  const popup = document.createElement('div');
  popup.className = className;
  popup.textContent = text;
  popup.style.left = `${rect.left + rect.width / 2}px`;
  popup.style.top = `${rect.top}px`;
  document.body.appendChild(popup);
  popup.addEventListener('animationend', () => popup.remove());
}

/** Float a "+N gems" indicator from the given anchor element. Used
 *  after a daily-gems claim so the player has a visual confirmation
 *  of the amount they gained — without it, the only feedback is the
 *  gem-balance number ticking up (easy to miss). */
export function spawnGemGainFlyaway(anchor: HTMLElement, amount: number): void {
  // Capture the rect now; the caller may re-render the surrounding
  // view immediately after this call, invalidating the anchor.
  const rect = anchor.getBoundingClientRect();
  spawnFlyaway(rect, 'gem-gain-popup', `+${amount} gems`);
}
